import React, { useEffect, useState } from 'react'

import { PlanPeriodDto, PlanPeriodSummary, benefitPlanPeriods } from 'core'
import { TaskStatus } from 'core/application/adminDashboard/adminTasks'
import {
  RenewalNotificationInfo,
  getRenewalNotification,
} from 'core/application/adminDashboard/benefitRenewal/renewalNotification/renewalNotification'
import { BenefitDesignStatus } from 'core/domain/benefit/benefitDesignStatus'

import { queryRequest } from '../../../common/RequestUtils'
import { BenefitPlanPeriodDropDown, Col, Row } from '../../../common/components'
import useAdminTasks from '../../../common/hooks/useAdminTasks'
import useLoginUser from '../../../common/hooks/useLoginUser'
import useQueryParams from '../../../common/hooks/useQueryParams'
import useQueryRequest from '../../../common/hooks/useQueryRequest'
import AllowanceSpent from '../common/allowanceSpent'
import Engagement from '../common/engagement'
import TotalSpendByCategory from '../common/totalSpendByCategory'
import WelcomeBox from '../common/welcomeBox'
import GchraAdminCountdownTimer from './adminCountdownTimer'
import AdminTasks from './adminTasks'

const GroupHraAdminDashboardHome = () => {
  const queryParams = useQueryParams()
  const planPeriodIdQueryParam = queryParams.get('planPeriodId')
  const [user] = useLoginUser()

  const [tasks] = useAdminTasks()
  const tasksCompleted = tasks && !tasks.some((x) => x.status != TaskStatus.Done)
  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState<PlanPeriodDto | null>()
  const [planPeriods] = useQueryRequest<PlanPeriodDto[]>(null, () => benefitPlanPeriods())
  const [renewalNotification, setRenewalNotification] = useState<RenewalNotificationInfo | null>(null)
  //const [renewalNotificationModal, setRenewalNotificationModal] = useState<boolean>(false)

  useEffect(() => {
    ;(async () => {
      if (planPeriods && planPeriods.length > 0) {
        const found = planPeriodIdQueryParam
          ? planPeriods.find((x) => x.id === planPeriodIdQueryParam)
          : planPeriods.find((x) => x.active == true)

        if (found) {
          setSelectedPlanPeriod(found)
        }
        const renewalNotificationVl = await queryRequest(() => getRenewalNotification())

        setRenewalNotification(renewalNotificationVl)
        //if (renewalNotification && !localStorage.getDismissedRenewalNotification()) setRenewalNotificationModal(true)
      }
    })()
  }, [planPeriods])

  return (
    <>
      <Row justify="end" className={'w-100 font-16 text-light-bold mb-16'}>
        {planPeriods && planPeriods.length > 1 && (
          <BenefitPlanPeriodDropDown
            planPeriods={planPeriods}
            showStartDateAndEndDate={true}
            onPlanPeriodSelected={(planPeriodId: string) => {
              const found = planPeriods.find((x) => x.id === planPeriodId)
              setSelectedPlanPeriod(found)
            }}
          />
        )}
      </Row>

      {tasks && selectedPlanPeriod && (
        <>
          {!tasksCompleted && <AdminTasks activePlanPeriod={selectedPlanPeriod} />}

          {tasksCompleted && (
            <>
              {renewalNotification && selectedPlanPeriod.benefitDesignStatus == BenefitDesignStatus.Signed && (
                <Row className={'mb-16'}>
                  <Col span={24}>
                    <GchraAdminCountdownTimer planPeriod={selectedPlanPeriod} user={user} />
                  </Col>
                </Row>
              )}

              <Row className={'mb-16'}>
                <Col span={24}>
                  <WelcomeBox planPeriodId={selectedPlanPeriod.id} />
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24} xl={9}>
                  <Row gutter={16}>
                    <Col xs={24} md={12} lg={12} xl={24} className="mb-16">
                      <AllowanceSpent planPeriod={selectedPlanPeriod} />
                    </Col>

                    <Col xs={24} md={12} lg={12} xl={24} className="mb-16">
                      {selectedPlanPeriod.active && <Engagement planPeriod={selectedPlanPeriod} />}
                    </Col>
                  </Row>
                </Col>

                <Col xs={24} md={12} lg={15} xl={15}>
                  {<TotalSpendByCategory planPeriod={selectedPlanPeriod} />}
                </Col>
              </Row>
            </>
          )}
        </>
      )}
    </>
  )
}

export default GroupHraAdminDashboardHome
